import React from "react";
import { NavLink, Link } from "react-router-dom";

function Navbar() {
  return (
    <header className="site-header">
      <nav className="site-nav" aria-label="Main navigation">
        <Link to="/" className="site-brand">
          <span className="site-brand-mark" aria-hidden="true">
            ✦
          </span>
          <span>OneRoof Beauty</span>
        </Link>

        <div className="site-nav-links">
          <NavLink to="/" end>
            Styles
          </NavLink>

          <NavLink to="/my-appointments">
            My Appointments
          </NavLink>

          <NavLink to="/booking-agreement">
            Booking Agreement
          </NavLink>

          <NavLink to="/contact">
            Contact
          </NavLink>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;